export default "__VITE_ASSET__DgCy1f7V__"